import React from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {getImageUrl} from "../../../context/ApplicationContextProvider";

/*
    props
    content_title: string               ContainerSubject에서 생성한 course_notice의 title
    content: string(DOM)                course_notice의 content로 저장되어 있는 DOM문자열
    set_never_show: func => void        ContainerSubject의 setLocalStorageNeverShowNotice 함수 참고
 */
const CourseNoticeModal = (props) => {
    // Dialog Context
    const dialog_utils = props.dialog_utils || {};
    const dialog_props = props.dialog_props || {};

    // css style
    const {view} = useComponentStyle();

    const onClickNeverShowButton = () => {
        // 하루동안 notice 보지않기
        props.set_never_show();
        dialog_utils.hideDialog && dialog_utils.hideDialog(dialog_props.id);
    };

    const onCloseModal = () => {
        dialog_utils.hideDialog && dialog_utils.hideDialog(dialog_props.id);
    };

    return (
        <view.ModalSection onClick={onCloseModal}>
            <view.ModalWrapper
                onClick={(e) => {
                    // 이벤트 버블링 방지
                    e.stopPropagation();
                }}>
                <view.ModalTitle>
                    <h3>강의 공지</h3>
                    <div className="modal-close-btn" onClick={onCloseModal} />
                </view.ModalTitle>
                <view.Content>
                    <span className="modal-content-title">{props.content_title}</span>
                    <p className="modal-content" dangerouslySetInnerHTML={{__html: props.content}} />
                </view.Content>
                {props.set_never_show && (
                    <view.NeverShowButton onClick={onClickNeverShowButton}>다시 보지 않기</view.NeverShowButton>
                )}
            </view.ModalWrapper>
        </view.ModalSection>
    );
};

export default CourseNoticeModal;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        view: {
            ModalSection: styled.div({
                position: "fixed",
                width: "100vw",
                height: "100vh",
                top: 0,
                left: 0,
                zIndex: "9999",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }),
            ModalWrapper: styled.div({
                overflowY: "visible",
                maxWidth: "40em",
                maxHeight: "inherit",
                height: "initial",
                backgroundColor: theme.colors.w,
                padding: "1.5em 1.5em 3em 1.5em",
                position: "relative",
                "@media (max-width: 320px)": {
                    padding: "1.5em 1em 3em 1em",
                },
            }),
            ModalTitle: styled.div({
                width: "100%",
                height: "2%",
                display: "flex",
                alignItems: "center",
                marginBottom: "1.5em",
                "& > h3": {
                    width: "93%",
                    margin: 0,
                    textAlign: "center",
                    color: theme.colors.bearu_primary,
                },
                "& > .modal-close-btn": {
                    cursor: "pointer",
                    width: "1.5em",
                    height: "1.5em",
                    background: `url(${getImageUrl(
                        "image/common/ic_close_button.png"
                    )})center center/contain no-repeat`,
                },
            }),
            Content: styled.div({
                "& > .modal-content-title": {
                    fontSize: theme.font_size.f17,
                    fontWeight: "600",
                    "@media (max-width: 320px)": {
                        fontSize: theme.font_size.f16,
                    },
                },
                "& > .modal-content": {
                    fontSize: theme.font_size.f14,
                    "@media (max-width: 320px)": {
                        fontSize: theme.font_size.f13,
                    },
                },
            }),
            NeverShowButton: styled.div({
                position: "absolute",
                bottom: "3%",
                right: "5%",
                width: "8em",
                height: "2em",
                boxSizing: "border-box",
                color: theme.colors.dg2,
                fontWeight: "600",
                fontSize: theme.font_size.f15,
                border: `2px solid ${theme.colors.lg2}`,
                borderRadius: ".3em",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: theme.box_shadow,
            }),
        },
    };
};
